// extracted by mini-css-extract-plugin
export var centered = "_j-6";
export var flexible = "_j-5";
export var footer = "_j-k";
export var footerBorder = "_j-l";
export var header = "_j-c";
export var headerBorder = "_j-d";
export var headerDefault = "_j-g";
export var headerMedium = "_j-h";
export var headerPadding = "_j-e";
export var iconAndTitle = "_j-f";
export var large = "_j-4";
export var largePadding = "_j-a";
export var medium = "_j-3";
export var mediumPadding = "_j-9";
export var modal = "_j-0";
export var modalContainer = "_j-b";
export var noPadding = "_j-7";
export var skinny = "_j-1";
export var small = "_j-2";
export var smallPadding = "_j-8";
export var subtitle = "_j-j";
export var title = "_j-i";